import styled from 'styled-components/macro'

const FlexAlignCenter = styled.div`
  display: flex;
  align-content: center;
`
const WhatsappHeading = styled.span`
  font-weight: 600;
  margin-left: 10px;
  font-size: 16px;
`
const PhoneInputPlaceHolder = styled.div`
  margin-top: 15px;
  color: #0D1536A6;
  font-size: 14px;
`
const PhoneInputError = styled.div`
  color: #E51A4D;
  margin-top: -10px;
  font-size: 12px;
`
const WhatsappHeadingDesc = styled.div`
  margin-top: 10px;
  line-height: 24px;
  color: #0D1536A6
`

const AskMeLaterBtn = styled.button`
  padding: 8px 20px;
  border: 1px solid var(--Azure500);
  border-radius: 4px;
`


export { FlexAlignCenter, WhatsappHeading, PhoneInputPlaceHolder,PhoneInputError,WhatsappHeadingDesc, AskMeLaterBtn }
